import { BookOpen } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { RC } from '@/lib/recipeCard/recipeCardStrings'
import { cn } from '@/lib/utils'

/**
 * The "Recipe" button a kitchen screen puts on a line. The screen decides
 * whether to render it (useRecipeCardLookup): it only appears where there is a
 * recipe to open.
 *
 * `iconOnly` is for the Kitchen Display's ticket line, where the row itself is
 * a button (tap = ready, long press = cooking). This one sits beside that row,
 * never inside it, and keeps its own pointer events to itself so opening a
 * recipe can never tick or start a line.
 */
export function RecipeCardButton({ name, onOpen, iconOnly = false, className }: {
  name: string
  onOpen: () => void
  iconOnly?: boolean
  className?: string
}) {
  return (
    <Button
      type="button"
      variant="outline"
      size={iconOnly ? 'icon' : 'sm'}
      className={cn(iconOnly ? 'shrink-0' : 'shrink-0 gap-1.5', className)}
      aria-label={RC.openFor(name)}
      title={RC.openFor(name)}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation()
        onOpen()
      }}
    >
      <BookOpen className="h-4 w-4" aria-hidden />
      {!iconOnly && RC.open}
    </Button>
  )
}
